export enum TileCacheType {
	OSM = "osm",
	OSM_BRIGHT = "osm-bright",
	POSITRON = "positron",
	ROUTEMAKER = "routemaker-compleet",
	OPENTOPO = "opentopo",
	SATELLITE = "luchtfoto",
	DEFAULT = "",
	IRIASGRIJS = "irias-grijs",
}